(() => {
  'use strict';
  const key = 'swapwear:bundle-journey:v1';
  const read = () => { try { return JSON.parse(sessionStorage.getItem(key)) || {}; } catch (_) { return {}; } };
  let state = read();
  if (!state || typeof state !== 'object' || Array.isArray(state)) state = {};
  const landing = /\/pages\/build-bundle-bases\/?$/.test(location.pathname);
  const homepage = location.pathname.replace(/\/$/, '') === String(window.Shopify?.routes?.root || '/').replace(/\/$/, '');
  const entry = landing || homepage || Boolean(document.querySelector?.('[data-bundle-configurator]'));
  state = { handle: state.handle, selection: state.selection, swaps: state.swaps, ...(entry ? { target: state.target } : {}) };
  if (landing) state.active = true;
  const save = () => { try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) {} };
  save();
  const changed = () => { save(); window.dispatchEvent(new CustomEvent('bundle:changed')); };
  const quantity = value => Math.max(0, Math.min(100, Math.trunc(Number(value) || 0)));
  const variantId = item => String(item?.variant_id || item?.id || '');
  const properties = item => Array.isArray(item?.properties) ? Object.fromEntries(item.properties) : (item?.properties || {});
  const signature = item => JSON.stringify([variantId(item), Object.entries(properties(item)).sort(), item?.selling_plan_allocation?.selling_plan?.id || '']);
  const paidPanel = item => /^(swappable patch|swappable panel|art panel)$/i.test(item?.product_type || item?.type || '') &&
    !/mystery|custom.patch/i.test([item?.product_title, item?.title, item?.handle].join(' ')) &&
    !properties(item).custom_id;
  const panels = cart => (cart?.items || []).filter(item => paidPanel(item) && quantity(item.quantity) > 0);
  window.swapwearSwapHandles = value => [...new Set((Array.isArray(value) ? value : [value]).flatMap(part => String(part || '').split(','))
    .map(handle => handle.trim().toLowerCase().replace(/-+$/, ''))
    .filter(handle => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle)))];
  const swapStorageKey = 'selected_swaps';
  const urlParams = new URLSearchParams(window.location?.search || location.search || '');
  const storedSwaps = window.swapwearStorage?.getJSON?.(swapStorageKey, state.swaps || []) ?? state.swaps ?? [];
  const requestedSwaps = window.swapwearSwapHandles(urlParams.has('swap') ? urlParams.getAll('swap') : storedSwaps)
    .map(handle => ({ handle, candidates: [...new Set([handle, handle.replace(/-(?:panel|patch)$/, '') + '-patch'])] }));
  const requestedSwapHandles = () => [...new Set(requestedSwaps.map(swap => swap.handle).filter(Boolean))];
  const saveSwaps = () => {
    state.swaps = requestedSwapHandles();
    window.swapwearStorage?.setJSON?.(swapStorageKey, state.swaps);
    save();
  };
  if (urlParams.has('swap')) saveSwaps();
  const productRequests = new Map();
  const imageRequests = new Map();
  let requestedSwapPromise;
  let requestedPreviewPromise;
  let requestedSwapRevision = 0;
  const loadSwap = async swap => {
    for (const handle of swap.candidates) {
      if (!productRequests.has(handle)) productRequests.set(handle, (async () => {
        try {
          const response = await window.swapwearFetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(handle) + '.js');
          if (!response.ok) return response.status === 404 ? null : undefined;
          const product = await response.json();
          return product?.handle === handle && paidPanel(product) && product.variants?.length ? product : null;
        } catch (_) { return undefined; }
      })());
      const product = await productRequests.get(handle);
      if (product === undefined) return null;
      if (!product) continue;
      swap.handle = handle;
      return product;
    }
    swap.handle = '';
    return null;
  };
  const usableImage = src => {
    if (!imageRequests.has(src)) imageRequests.set(src, new Promise(resolve => {
      const image = new window.Image();
      const finish = valid => {
        clearTimeout(timer);
        image.onload = image.onerror = null;
        resolve(valid);
      };
      const timer = setTimeout(() => finish(false), 8000);
      image.onload = () => finish(image.naturalWidth > 0);
      image.onerror = () => finish(false);
      image.src = src;
    }));
    return imageRequests.get(src);
  };
  const selectedBase = cart => {
    const items = (cart?.items || []).filter(item => quantity(item.quantity) > 0);
    return items.find(item => signature(item) === state.intent?.baseSignature) ||
      items.find(item => (cart?.bases || []).some(base => base.handle === item.handle) ||
        properties(item)._bundle_role === 'base' || /^(jacket|hoodie|backpack|base)$/i.test(item.product_type || item.type || '')) || null;
  };
  let retry = null;
  const flush = () => {
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;
    for (const [name, data] of Object.entries(state.pending || {})) {
      try {
        const result = publish.call(window.Shopify.analytics, `swapwear_${name}`, data);
        if (result === false) continue;
        state.events = { ...state.events, [name]: true };
        delete state.pending[name];
      } catch (_) { /* Keep the event for the next SDK-ready attempt. */ }
    }
    save();
    if (!Object.keys(state.pending || {}).length && retry) { clearInterval(retry); retry = null; }
  };
  const emit = (name, data = {}) => {
    if (!state.active || state.events?.[name] || state.pending?.[name]) return;
    // Shopify owns checkout_started and checkout_completed/purchase.
    state.pending = { ...state.pending, [name]: {
      source: state.source || 'build-bundle-bases', target_panels: state.target || null, ...data
    } };
    save(); flush();
    if (Object.keys(state.pending || {}).length && !retry) retry = setInterval(flush, 1000);
  };
  window.swapwearBundleJourney = {
    isLanding() { return landing; },
    isArtStep() { return false; },
    hasIntent() { return Boolean(state.intent?.id); },
    intent() { return state.intent || null; },
    panels,
    nextPanelOffer(cart, tiers, referencePrice) {
      const items = panels(cart);
      const count = items.reduce((sum, item) => sum + quantity(item.quantity), 0);
      const eligible = (tiers || []).filter(tier => !tier.bogo && Number(tier.discount) > 0 && Number(tier.req_art) > 0).sort((a, b) => Number(a.req_art) - Number(b.req_art));
      const tier = eligible.find(tier => Number(tier.req_art) > count) || eligible.at(-1);
      const original = Number(referencePrice) || Number(items[0]?.original_price || items[0]?.price || 0);
      if (!tier || !original) return null;
      return { count, target: Number(tier.req_art), remaining: Math.max(0, Number(tier.req_art) - count), original, price: Math.max(0, Math.round(original * (1 - Number(tier.discount) / 100))) };
    },
    requestedSwapHandles,
    setRequestedSwaps(value) {
      requestedSwaps.splice(0, requestedSwaps.length, ...window.swapwearSwapHandles(value).map(handle => ({ handle, candidates: [...new Set([handle, handle.replace(/-(?:panel|patch)$/, '') + '-patch'])] })));
      requestedSwapRevision++;
      requestedSwapPromise = requestedPreviewPromise = undefined;
      saveSwaps();
    },
    requestedSwapHandle() { return requestedSwapHandles()[0] || ''; },
    loadRequestedSwaps() {
      if (!requestedSwapPromise) {
        const revision = requestedSwapRevision;
        requestedSwapPromise = Promise.all(requestedSwaps.map(loadSwap)).then(products => {
          if (revision === requestedSwapRevision) saveSwaps();
          return products.filter((product, index) => product && products.findIndex(item => item?.handle === product.handle) === index);
        });
      }
      return requestedSwapPromise;
    },
    async loadRequestedSwap() { return (await this.loadRequestedSwaps())[0] || null; },
    loadRequestedSwapPreviews() {
      if (!requestedPreviewPromise) requestedPreviewPromise = this.loadRequestedSwaps().then(products => Promise.all(products.map(async product => {
        const sources = [...new Set([product.featured_image, ...(product.images || [])]
          .map(image => typeof image === 'string' ? image : image?.src || image?.url || '').filter(Boolean))];
        for (const source of sources) {
          const image = window.buildImageUrlWithWidth?.(source, 1000) || source;
          if (await usableImage(image)) return { ...product, product_title: product.title, image, quantity: 1 };
        }
        return null;
      }))).then(products => products.filter(Boolean));
      return requestedPreviewPromise;
    },
    selectedBase,
    panelLine(cart, id) { return panels(cart).find(item => variantId(item) === String(id)) || null; },
    panelProperties(product) {
      return {};
    },
    baseProperties() {
      return {};
    },
    begin(product, variant, target, panelPrice, cart, setName = '') {
      if (!entry || !product?.handle || !variant?.id || !quantity(target)) return;
      state.active = true;
      state.source = homepage ? 'homepage-bundle' : landing ? 'build-bundle-bases' : 'bundle-banner';
      const existing = (cart?.items || []).find(item => variantId(item) === String(variant.id));
      const id = state.intent?.id || crypto.randomUUID();
      const baseProperties = existing ? properties(existing) : {};
      state.target = quantity(target);
      state.intent = { id, setName: String(setName), base: { handle: product.handle, title: product.title, type: product.type, variantId: variant.id, variantTitle: variant.public_title || variant.title || '', price: Number(variant.price || 0) },
        panelPrice: Number(panelPrice || 0), baseSignature: signature(existing || { id: variant.id, properties: baseProperties }) };
      changed();
    },
    rememberBaseLine(item) { if (entry && state.intent && item?.id) { state.intent.baseSignature = signature(item); changed(); } },
    artUrl() {
      const params = new URLSearchParams(state.intent ? { base: state.intent.base.handle, base_variant: String(state.intent.base.variantId) } : {});
      if (requestedSwapHandles().length) params.set('swap', requestedSwapHandles().join(','));
      return '/collections/build-bundle' + (params.size ? '?' + params : '');
    },
    progress(cart) {
      const items = panels(cart);
      const count = items.reduce((sum, item) => sum + quantity(item.quantity), 0);
      const base = selectedBase(cart);
      const otherCount = (cart?.items || []).reduce((sum, item) => {
        if (paidPanel(item) || /mystery/i.test(item.product_title || item.title || '')) return sum;
        return sum + Math.max(0, quantity(item.quantity) - (item === base ? 1 : 0));
      }, 0);
      return { items, count, base, target: quantity(state.target), remaining: Math.max(0, quantity(state.target) - count), extra: Math.max(0, count - quantity(state.target)), complete: Boolean(base && count >= state.target && state.target > 0), otherCount };
    },
    plannedPrice(cart, profile) {
      const intent = state.intent;
      if (!intent) return 0;
      const chosen = panels(cart);
      const count = chosen.reduce((sum, item) => sum + quantity(item.quantity), 0);
      const plannedCart = { items: [{ handle: intent.base.handle, quantity: 1 }, { product_type: 'Art Panel', product_title: 'Chosen art', quantity: Math.max(count, state.target) }] };
      const discount = (type, handle) => Number(window.buildPriceHelpers?.liveDiscount(type, profile, plannedCart, handle) || 0);
      const basePrice = intent.base.price * (1 - discount(intent.base.type, intent.base.handle) / 100);
      const artPrice = chosen.reduce((sum, item) => sum + Number(item.original_line_price ?? Number(item.price || 0) * quantity(item.quantity)), 0) + Math.max(0, state.target - count) * intent.panelPrice;
      return Math.round(basePrice + artPrice * (1 - discount('Art Panel', '') / 100));
    },
    giftState(cart, app) {
      const gift = app?.mystery_data?.[2];
      if (!gift) return 'none';
      const id = String(gift.rewardVariantId?.id || gift.rewardVariantId?.value || gift.rewardVariantId || '').replace('gid://shopify/ProductVariant/', '');
      const line = (cart?.items || []).find(item => variantId(item) === id || (gift.title && item.product_title === gift.title));
      if (line && Number(line.final_line_price ?? line.line_price) === 0) return 'added';
      if (app?._addingMystery2 || app?.canAddMystery2Reward?.()) return 'pending';
      return gift.active && Number(gift.req) > 0 ? 'threshold' : 'none';
    },
    baseHandle() {
      const index = window.swapwearStorage?.getJSON?.('selected_base', null);
      const base = Number.isInteger(index) ? window.__initialData?.bases?.[index] : null;
      return base?.handle || state.handle || state.selection?.handle || '';
    },
    rememberBase(handle) {
      if (!handle) return;
      const index = (window.__initialData?.bases || []).findIndex(base => base.handle === handle);
      if (index >= 0) window.swapwearStorage?.setJSON?.('selected_base', index);
      state.handle = handle;
      save();
    },
    selectionFor(product) {
      const options = state.selection?.options;
      if (!options || !product?.variants) return null;
      return product.variants.find(v => v.available && product.options.every((_, i) =>
        String(v[`option${i + 1}`]) === String(options[i]))) || null;
    },
    rememberSelection(product, variant) {
      if (!entry) return;
      this.rememberBase(product.handle);
      state.selection = { handle: product.handle, id: variant.id,
        options: product.options.map((_, i) => variant[`option${i + 1}`]) };
      save(); emit('builder_started', { product_id: product.id });
    },
    target() { return Number(state.target || 0); },
    setTarget(count, started = true) { if (!entry) return; state.target = quantity(count); save(); if (started) emit('builder_started'); },
    track: emit
  };
  if (!state.active && !entry) return;
  save(); flush();
  if (Object.keys(state.pending || {}).length && !retry) retry = setInterval(flush, 1000);
  document.addEventListener('click', event => {
    if (event.target.closest?.('.build-set-selector, .product-base-carousel, .build-collection .options')) emit('builder_started');
  }, { passive: true });
})();
